import { render, staticRenderFns } from "./UploadImg.vue?vue&type=template&id=3232dcd2&"
import script from "./UploadImg.vue?vue&type=script&lang=js&"
export * from "./UploadImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\vsProject\\dsf-product-exam\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3232dcd2')) {
      api.createRecord('3232dcd2', component.options)
    } else {
      api.reload('3232dcd2', component.options)
    }
    module.hot.accept("./UploadImg.vue?vue&type=template&id=3232dcd2&", function () {
      api.rerender('3232dcd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/components/QuestionItem/UploadImg.vue"
export default component.exports